/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 *
 * Misma cáscara que SettingsFormEditModal / POS: ModalShell + footer Cancelar/CTA.
 */
import React from 'react';
import { ActivityIndicator, Pressable, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { ModalShell } from '../../../shared/modals/ModalShell'
import { modalExperience } from '../../../shared/modals/modalExperience.styles';
import { posSharedUi as posUi } from '../../../shared/ui/posSharedUi';
import { openLegalUrl } from '../../../shared/legalUrls';
import { ticketColors, ticketFonts } from '../../../shared/theme/ticketColors';

type Props = {
  visible: boolean;
  loading?: boolean;
  onAccept: () => void;
  onCancel: () => void;
};

const TC_POINTS = [
  'Vuelto publica tu catálogo y arma el pedido. La venta es de tu comercio.',
  'Los horarios, precios y stock los mantenés vos.',
  'Si un precio o el stock está mal, la responsabilidad es tuya.',
  'El cobro online va a tu Mercado Pago. Vuelto no se queda con un porcentaje.',
  'Podés apagar la tienda cuando quieras.',
];

export function TermsModal({ visible, loading = false, onAccept, onCancel }: Props) {
  const handleClose = () => {
    if (!loading) onCancel();
  };

  return (
    <ModalShell
      visible={visible}
      onClose={handleClose}
      title="Términos y condiciones"
      subtitle="Catálogo público y pedidos online"
      closeAccessibilityLabel="Cerrar términos y condiciones"
      keyboardAvoiding={false}
      widthVariant="standard"
      footer={
        <View style={[posUi.modalActions, modalExperience.footerActions]}>
          <TouchableOpacity
            style={[posUi.secondaryButton, posUi.modalButtonHalf]}
            onPress={handleClose}
            disabled={loading}
            accessibilityRole="button"
            accessibilityLabel="Cancelar"
          >
            <Text style={posUi.secondaryButtonText}>Cancelar</Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={[posUi.primaryButton, posUi.modalButtonHalf, loading && posUi.disabledCard]}
            onPress={onAccept}
            disabled={loading}
            accessibilityRole="button"
            accessibilityLabel="Acepto"
          >
            {loading ? (
              <ActivityIndicator color={ticketColors.goldInk} />
            ) : (
              <Text style={posUi.primaryButtonText}>Acepto</Text>
            )}
          </TouchableOpacity>
        </View>
      }
    >
      <View style={modalExperience.formPanel}>
        <Text style={local.intro}>Al prender la tienda aceptás:</Text>
        {TC_POINTS.map((point, i) => (
          <Text key={i} style={local.point}>
            {i + 1}. {point}
          </Text>
        ))}
        <Pressable
          onPress={() => void openLegalUrl('terms')}
          accessibilityRole="link"
          accessibilityLabel="Ver términos completos"
          style={local.linkWrap}
        >
          <Text style={local.link}>Ver términos completos</Text>
        </Pressable>
      </View>
    </ModalShell>
  );
}

const local = StyleSheet.create({
  intro: {
    fontSize: 13,
    fontWeight: '600',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
    lineHeight: 19,
    marginBottom: 4,
  },
  point: {
    fontSize: 13,
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
    lineHeight: 19,
  },
  linkWrap: {
    marginTop: 8,
    alignSelf: 'flex-start',
  },
  link: {
    fontSize: 13,
    fontWeight: '600',
    color: ticketColors.gold,
    fontFamily: ticketFonts.sans,
    textDecorationLine: 'underline',
  },
});
